export enum StaffFullnessStatusEnum {
    ALL = '0',
    FULL = '1',
    EMPTY = '2',
}
